<template>
  <div class="navigation">
    <div class="navigation__primary">
      <router-link to="/">
        <Logo class="logo--nav" @click="$router.push('/')"/>
      </router-link>

      <div class="navigation__container">
        <div class="navigation__links-container">
          <MobileNav :user="user" />

          <DesktopNav :user="user" />
        </div>

        <Profile :user="user" />
      </div>
    </div>

    <SecondaryNav/>
  </div>
</template>

<script>
import Profile from './Profile';
import MobileNav from './MobileNav'
import DesktopNav from './DesktopNav'
import SecondaryNav from './SecondaryNav'
import Logo from '../elements/Logo';
import { mapGetters } from 'vuex';

export default {
  components: {
    Profile, MobileNav, Logo, SecondaryNav, DesktopNav
  },
  computed: {
    ...mapGetters(['user']),
  }
}
</script>

<style lang="scss" scoped>
.navigation {
  display: flex;
  flex-direction: column;

  &__primary {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 6em;
    max-width: $maxWidth;
    width: 100%;
    margin: 0 auto;

    @include breakpoints(small) {
      height: 9em;
    }
  }

  &__container {
    display: flex;
    align-items: center;
  }

  &__links-container {
    display: flex;
  }
}
</style>